import { render, staticRenderFns } from "./SeatsChart.vue?vue&type=template&id=ec221b56&scoped=true&"
import script from "./SeatsChart.vue?vue&type=script&lang=js&"
export * from "./SeatsChart.vue?vue&type=script&lang=js&"
import style0 from "./SeatsChart.vue?vue&type=style&index=0&id=ec221b56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../var/www/html/film-screening-production/vuejs/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec221b56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../var/www/html/film-screening-production/vuejs/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VLayout})
